import React from 'react'
import { DropDown } from '../../../commons'
import { DropDownType } from '../../../../commonTypes/clientDirectoryTypes';
import { serviceTaxRegisteredDropDown } from '../../../../constant/clientDirectoryDropDown';
type AppProps = {
    billingDetails: any;
    setTaxAndBillingDetails: any;
    isDisabled?:boolean
}
const Billing = ({
    billingDetails,
    setTaxAndBillingDetails,
    isDisabled
}: AppProps) => {
    const sendIncoiceOption = [
        {
            value: "No",
            label: "No"
        },
        {
            value: "Yes",
            label: "Yes"
        }
    ]

    const option = [
        {
            value: "",
            label: ""
        }
    ]

    const handleSendIncoiceChange = (data: any) => {
        setTaxAndBillingDetails((prev: any) => {
            return {
                ...prev,
                billingDetails: {
                    ...prev.billingDetails,
                    sendInvoiceReminder: {
                        value: data?.value,
                        label: data?.label
                    }
                }
            }
        })
    }

    const handleBillingDropDownChange = (data: DropDownType, name: string) => {
        if (name === "entity") {
            setTaxAndBillingDetails((prev: any) => {
                return {
                    ...prev,
                    billingDetails: {
                        ...prev.billingDetails,
                        billingEntity: {
                            value: data?.value,
                            label: data?.label
                        }
                    }
                }
            })
        }
       else if (name === "interest") {
            setTaxAndBillingDetails((prev: any) => {
                return {
                    ...prev,
                    billingDetails: {
                        ...prev.billingDetails,
                        chargeInterest: {
                            value: data?.value,
                            label: data?.label
                        }
                    }
                }
            })
        }
       else if (name === "period") {
            setTaxAndBillingDetails((prev: any) => {
                return {
                    ...prev,
                    billingDetails: {
                        ...prev.billingDetails,
                        interestPeriod: {
                            value: data?.value,
                            label: data?.label
                        }
                    }
                }
            })
        }
       else if (name === "monthly") {
            setTaxAndBillingDetails((prev: any) => {
                return {
                    ...prev,
                    billingDetails: {
                        ...prev.billingDetails,
                        chargeMonthlyDisbursement: {
                            value: data?.value,
                            label: data?.label
                        }
                    }
                }
            })
        }
    }

    const handleInterestRateChange=(data:any)=>{
        setTaxAndBillingDetails((prev: any) => {
            return {
                ...prev,
                billingDetails: {
                    ...prev.billingDetails,
                    interestRate:data.target.value
                }
            }
        })
    }
    const handleTargetHoursChange=(data:any)=>{
        setTaxAndBillingDetails((prev: any) => {
            return {
                ...prev,
                billingDetails: {
                    ...prev.billingDetails,
                    targetHours:data.target.value
                }
            }
        })
    }
    
    return (
        <>
            <div className='row'>
                <div className='col-md-3'>
                    <label htmlFor='Billing Entity'>Billing Entity</label>
                    <DropDown
                        options={sendIncoiceOption}
                        value={billingDetails?.billingEntity}
                        handleChange={(e) => handleBillingDropDownChange(e, "entity")}
                        disabled={isDisabled}
                    />
                </div>
                <div className='col-md-3'>
                    <label htmlFor='Charge Interest'>Charge Interest</label>
                    <DropDown
                        options={sendIncoiceOption}
                        value={billingDetails?.chargeInterest}
                        handleChange={(e) => handleBillingDropDownChange(e, "interest")}
                        disabled={isDisabled}
                    />
                </div>
                <div className="col-md-3">
                    <label htmlFor="Interest Rate %">Interest Rate %</label>
                    <div className="d-flex flex-row position-relative">
                        <input
                            type="number"
                            className="form-control"
                            name="interestRate"
                            value={billingDetails?.interestRate}
                            onChange={handleInterestRateChange}
                            onWheel={(event) => event.currentTarget.blur()}
                            disabled={isDisabled}
                        />
                    </div>
                </div>
                <div className='col-md-3'>
                    <label htmlFor='Interest Period'>Interest Period</label>
                    <DropDown
                        options={option}
                        disabled
                        value={billingDetails?.interestPeriod}
                        handleChange={(e) => handleBillingDropDownChange(e, "period")}
                    />
                </div>
            </div>
            <div className='row'>
                <div className='col-md-3 mt-3'>
                    <label htmlFor='Charge Monthly  Disbursement'>Charge Monthly  Disbursement</label>
                    <DropDown
                        options={sendIncoiceOption}
                        value={billingDetails?.chargeMonthlyDisbursement}
                        handleChange={(e) => handleBillingDropDownChange(e, "monthly")}
                        disabled={isDisabled}
                    />
                </div>
                <div className='col-md-3 mt-3'>
                    <label htmlFor='Send Invoice Reminder'>Send Invoice Reminder</label>
                    <DropDown
                        options={sendIncoiceOption}
                        value={billingDetails?.sendInvoiceReminder}
                        handleChange={handleSendIncoiceChange}
                        disabled={isDisabled}
                    />
                </div>
                <div className="col-md-3 mt-3">
                    <label htmlFor="Target Hours">Target Hours</label>
                    <div className="d-flex flex-row position-relative">
                        <input
                            type="number"
                            className="form-control"
                            name="targetHours"
                            value={billingDetails?.targetHours}
                            onChange={handleTargetHoursChange}
                            onWheel={(event) => event.currentTarget.blur()}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Billing